var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "breadcrumb" }, [_c("navbar")], 1),
      _vm._m(0),
      _c("div", { staticClass: "content" }, [
        _c("h3", [_vm._v("APP、H5站内信推送模板")]),
        _c("h4", [_vm._v("粉丝新增模板")]),
        _c(
          "div",
          [
            _vm.templateForFans.paramList
              ? _c(
                  "el-form",
                  {
                    ref: "sInsideForm",
                    staticClass: "template-operation",
                    attrs: {
                      inline: true,
                      model: _vm.sInsideForm,
                      size: "small",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入", clearable: "" },
                          model: {
                            value:
                              _vm.templateForFans.paramList[0].paramContent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.templateForFans.paramList[0],
                                "paramContent",
                                $$v
                              )
                            },
                            expression:
                              "templateForFans.paramList[0].paramContent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "status" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择用户昵称" },
                            model: {
                              value:
                                _vm.templateForFans.paramList[1].paramContent,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.templateForFans.paramList[1],
                                  "paramContent",
                                  $$v
                                )
                              },
                              expression:
                                "templateForFans.paramList[1].paramContent",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.message_customer_user_info2,
                            function (item) {
                              return _c("el-option", {
                                key: item.dictId,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "name1" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入",
                            clearable: "",
                            maxlength: "30",
                            "show-word-limit": "",
                          },
                          model: {
                            value:
                              _vm.templateForFans.paramList[2].paramContent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.templateForFans.paramList[2],
                                "paramContent",
                                $$v
                              )
                            },
                            expression:
                              "templateForFans.paramList[2].paramContent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "form-operation-but" },
                      [
                        _vm.templateForFans.status === 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.siteInsideMsgEnable(
                                      _vm.templateForFans.status
                                    )
                                  },
                                },
                              },
                              [_vm._v("停用")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.siteInsideMsgEnable(
                                      _vm.templateForFans.status
                                    )
                                  },
                                },
                              },
                              [_vm._v("开启")]
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "operation-but" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.siteInsideMsgSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "reset",
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.siteInsideMsgSelectList("opt")
                      },
                    },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content table" },
        [
          _vm._m(1),
          _c(
            "h4",
            [
              _c("label", [_vm._v(_vm._s(_vm.fans.title))]),
              _c(
                "el-button",
                {
                  staticClass: "template-add",
                  attrs: { type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showDialog("add")
                    },
                  },
                },
                [_vm._v("新增模板动作")]
              ),
            ],
            1
          ),
          _c("push-table", {
            attrs: {
              typeStr: _vm.fans.type,
              list: _vm.fans.page.list,
              config: _vm.fans.config,
            },
            on: { onOperation: _vm.actionOperation },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content table" },
        [
          _c("h4", [_c("label", [_vm._v(_vm._s(_vm.miniProgram.title))])]),
          _c("push-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.miniProgram.loading,
                expression: "miniProgram.loading",
              },
            ],
            attrs: {
              typeStr: _vm.miniProgram.type,
              list: _vm.miniProgram.page.list,
              config: _vm.miniProgram.config,
            },
            on: { onOperation: _vm.actionOperation },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content table" },
        [
          _c("h4", [_c("label", [_vm._v(_vm._s(_vm.weixin.title))])]),
          _c("push-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.weixin.loading,
                expression: "weixin.loading",
              },
            ],
            attrs: {
              typeStr: _vm.weixin.type,
              list: _vm.weixin.page.list,
              config: _vm.weixin.config,
            },
            on: { onOperation: _vm.actionOperation },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
            "custom-class":
              _vm.dialog.type === "modifyState" ? "modify-state" : "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          [
            _c(
              "el-form",
              {
                ref: "templateForm",
                staticClass: "dialog-form",
                attrs: {
                  model: _vm.templateForm,
                  rules: _vm.rules,
                  "label-width": "110px",
                },
              },
              [
                _vm.dialog.type === "add"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "模板动作", prop: "name" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择模板动作" },
                            model: {
                              value: _vm.templateForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.templateForm, "name", $$v)
                              },
                              expression: "templateForm.name",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "粉丝关注", value: "粉丝关注" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "模板", prop: "templateId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "请选择模板",
                        },
                        on: { change: _vm.onChangeTempl },
                        model: {
                          value: _vm.templateForm.templateId,
                          callback: function ($$v) {
                            _vm.$set(_vm.templateForm, "templateId", $$v)
                          },
                          expression: "templateForm.templateId",
                        },
                      },
                      _vm._l(_vm.templateDataList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                    _c("div", [_vm._v(_vm._s(_vm.templateContent))]),
                  ],
                  1
                ),
                _vm._l(_vm.templateForm.paramList, function (pItem, pIndex) {
                  return [
                    _vm.templateForm.paramList.length > 0
                      ? _c(
                          "el-form-item",
                          {
                            key: pIndex,
                            attrs: { label: "参数", prop: "paramList" },
                          },
                          [
                            _vm.templateForm.paramList.length > 1
                              ? _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [_vm._v("参数" + _vm._s(pIndex + 1))]
                                )
                              : _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [_vm._v("参数")]
                                ),
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择参数",
                                },
                                model: {
                                  value:
                                    _vm.templateForm.paramList[pIndex]
                                      .paramContent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.templateForm.paramList[pIndex],
                                      "paramContent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "templateForm.paramList[pIndex].paramContent",
                                },
                              },
                              _vm._l(
                                _vm.dictionaries.message_customer_user_info,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: item.dictId,
                                    attrs: {
                                      label: item.dictName,
                                      value: item.dictId,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                }),
                _c(
                  "el-form-item",
                  { attrs: { label: "模板签名", prop: "signType" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "请选择模板签名",
                        },
                        model: {
                          value: _vm.templateForm.signType,
                          callback: function ($$v) {
                            _vm.$set(_vm.templateForm, "signType", $$v)
                          },
                          expression: "templateForm.signType",
                        },
                      },
                      _vm._l(_vm.dictionaries.teng_xun_sign, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.centerDialog } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitDialog } },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("固定推送")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [_c("label", [_vm._v("第三方模板列表")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }